import React, { useContext, useEffect, useState } from 'react'
import { PageContext, ToastContext, UserContext } from "../App";
import { HorizontalLayout, VerticalLayout } from "../components/layout";
import { TitleAtom } from "../atoms/titleAtom";
import { IconButton, ModalButton, StandardButton } from "../atoms/buttons";
import { TitleDescription } from "../components/titleDescription";
import { Alert } from "../components/alert";
import { InputForm, TextAreaForm } from "../atoms/input";
import { postAPI, updateAPI } from "../api/api";
import { margin } from "polished";

export default function CourseInfo({ quizStructure,loadCourse, loading, setScoreModalVisible, courseData, isDeactivated}) {
    const [activeContent, setActiveContent] = useState(2);
    const [aiLoading, setAiLoading] = useState(false);
    const [aiReload, setAiReload] = useState(false);
    const [courseName, setCourseName] = useState(courseData.title);
    const [courseDescription, setCourseDescription] = useState(courseData.description);
    const [courseExtraDescription, setCourseExtraDescription] = useState(courseData.extra_description);
    const toastContext = useContext(ToastContext);
    const navigationContext = useContext(PageContext)
    useEffect(() => {
        setCourseName(courseData.title);
        setCourseDescription(courseData.description);
        setCourseExtraDescription(courseData.extra_description);
    }, [courseData]);

    
    const handleEditCourse = async () => {
        if (!courseName.trim() || !courseDescription.trim()) {
            toastContext.showToast(<>De titel en beschrijving mogen niet leeg zijn.</>, "error", 2000);
            return;
        }
        const query = "api/courses/edit";
        const body = { id_course: courseData.id_course, title: courseName, description: courseDescription, extra_description: courseExtraDescription };
        const response = await postAPI(query, body);

        if (response.status === "ok") {
            toastContext.showToast(<>Cursus is succesvol bijgewerkt!</>,"success", 1500);
            await loadCourse()
            setActiveContent(2); 
        } else {
            toastContext.showToast(<>Er is iets misgegaan bij het bijwerken van de cursus. Probeer het later opnieuw.</>, "error", 2000);
        }
    };
    const handleAiDescription = async () => {
        setAiLoading(true);
        const query = "api/courses/generate/description"
        console.log("data", courseData)
        const res = await postAPI(query, courseData);
        console.log("res", res)
        if (res.status === "ok"){
            setAiReload(true)
            toastContext.showToast(<>AI-beschrijving succesvol gegenereerd!</>, "success", 1500);
            await loadCourse()
        }
        setAiLoading(false);
    }
  const validateLessons = () => {
    const emptyLessons = quizStructure.filter(lesson => 
      !lesson.title || 
      !lesson.description || 
      !lesson.module_content || 
      lesson.module_content.trim() === ""
  );

  if (emptyLessons.length === 0) {
      console.log('error')
      return false; 
  }
  return true;
  };
      const publishLesson = async () => {
        if (!validateLessons()) {
          return;
        }
        const courseId = navigationContext.sidebar.courseID
        const query = "api/courses/publish"
        const body = {}
        body["id_course"] = courseId
        body["image_url"] = courseData?.image_url
        await updateAPI(query, body)
        navigationContext.handleNavigation({ courseID: 0, navigation: 2, enrollment: 0 })
      }
      const startCourse = async () => {
        const query = "api/assessments/start-assessment"
        const body = {}
        const courseId = navigationContext.sidebar.courseID
        body["id_course"] = courseId
    
        const post = await postAPI(query, body)
        if (post.status === "ok") {
          navigationContext.handleNavigation({ courseID: courseId, navigation: 10, enrollment: post.data })
        }
      }

       const renderContent = () => {
        switch (activeContent) {
            case 1:
                return (
                    <EditCourseContent
                        courseName={courseName}
                        setCourseName={setCourseName}
                        courseDescription={courseDescription}
                        setCourseDescription={setCourseDescription}
                        courseExtraDescription={courseExtraDescription}
                        setCourseExtraDescription={setCourseExtraDescription}
                        handleEditCourse={handleEditCourse}
                        dismiss={() => setActiveContent(2)}
                        handleAiGenerate={handleAiDescription}
                        aiLoading={aiLoading}
                        aiReload={aiReload}
                    />
                );
            case 2:
                return (
                    <InfoContent
                        editing={activeContent === 1}
                        courseData={courseData}
                        loading={loading}
                        isDeactivated={isDeactivated}
                        startCourse={startCourse}
                        publishLesson={publishLesson}
                        setScoreModalVisible={setScoreModalVisible}
                        setActiveContent={setActiveContent}
                    />
                );
                default: return <></>
        
        }
    };
    return (
        <VerticalLayout className={`vertical phone-publish card-background-color ${courseData?.published === 2 ? "inactive" : ""}`} style={{ width: "100%" }}>
            {renderContent()}
        </VerticalLayout>
    );
}

const InfoContent = ({ isDeactivated, loading, startCourse, publishLesson, editing, courseData, setScoreModalVisible, setActiveContent }) => {
    const difficulty = () => {
        console.log("courseData difficulty", courseData?.difficulty);
        switch (courseData?.difficulty) {
            case 1 : return "Makkelijk"
            case 2 : return "Gemiddeld"
            case 3 : return "Moeilijk"
            default: return <></>
        }


    }
    
    const INFO_ITEMS = (courseData) => [
        { title: "Moeilijkheidsgraad", description: difficulty(), icon: "brain" },
        { title: "Tijdsduur", description: courseData?.duration , icon: "hourglass-2"},
        { title: "Aantal Lessen", description: courseData?.lessonCount , icon: "book-shelf"},
        { title: "Video", description: `${courseData?.videoCount || "Geen"} ${courseData?.videoCount === 1 ? "Video" : "Videos"}`, icon: "video-small-2"},
        { title: "Taal", description: courseData?.language , icon: "school" },
    ];

    const navigationContext = useContext(PageContext);
    const CourseDone = courseData.active === 2;
    console.log("courseData", courseData)
    return (
        <>
            <VerticalLayout className="phone-publish-content standard-margin-bottom" style={{ height: "unset", width: "auto" }}>
                <TitleAtom className={"standard-margin"} title={"Cursus inhoud"} />
                <VerticalLayout style={{margin: "0 1rem", gap: ".45rem", width: "auto", }}>
                    {INFO_ITEMS(courseData).map((item, index) => (
                        <TitleDescription
                            icon2={item.icon}
                            key={index}
                            className={"info-items"}
                            style={{ margin: "0", gap: ".6rem", fontSize: "2rem" }}
                            title={item.title}
                            description={item.description}
                        />
                    ))}
                </VerticalLayout>
            </VerticalLayout>
            <HorizontalLayout className="space-between" style={{ gap: "1rem", marginTop: "auto", width: "auto", marginBottom:"1rem", marginLeft:"1rem", marginRight:"1rem"}}> 
                {/* {!isDeactivated && !CourseDone && !loading && <IconButton
                    onClick={() => setActiveContent(1)}
                    style={{ padding: "0.5rem", height: "100%", width: editing && "100%", backgroundColor: "#F7F7F7", borderRadius: "calc(.25rem * var(--br-scale))" }}
                    icon2={"plus"}
                />}
                {!isDeactivated && !CourseDone && !loading && (
                    <ModalButton
                        title={courseData?.published? (navigationContext.sidebar.userId === "@me" || navigationContext.sidebar.userId === 0 ? "Start mijn cursus" : "Start cursus"): `Cursus publiceren`}
                        onClick={courseData?.published ? startCourse : publishLesson}
                        style={{width: "100%"}}
                    />
                )} */}
                {!isDeactivated && !loading && <IconButton
                    onClick={() => setActiveContent(1)}
                    style={{ padding: "0.5rem", height: "100%", width: editing && "100%", backgroundColor: "#F7F7F7", borderRadius: "calc(.25rem * var(--br-scale))" }}
                    icon2={"plus"}
                />}
                {!isDeactivated && !loading && !CourseDone &&  (
                    <ModalButton
                        title={courseData?.published? (navigationContext.sidebar.userId === "@me" || navigationContext.sidebar.userId === 0 ? "Start mijn cursus" : "Start cursus"): `Cursus publiceren`}
                        onClick={courseData?.published ? startCourse : publishLesson}
                        style={{width: "100%"}}
                    />
                )}
                
                {CourseDone && !loading && (
                    <StandardButton className={"center"} style={{ width: "100%", marginLeft: 0, }} backgroundColor={"primary-500"} textColor={"grey-100"} title={"Bekijk score"} onClick={() => setScoreModalVisible(true)} />
                )}
            </HorizontalLayout>
        </>
    );
};


const EditCourseContent = ({aiReload, handleAiGenerate,aiLoading, setCourseName, courseName, setCourseDescription, courseDescription, handleEditCourse, dismiss, setCourseExtraDescription, courseExtraDescription}) => {
  return (
    <>
      <VerticalLayout style={{ borderRadius: "0.5rem", backgroundColor: "var(--white)", width:"auto", }}>
        <TitleAtom className="standard-margin" title={"Cursus bewerken"} />
        <VerticalLayout style={{margin: "0 1rem .75rem 1rem", width: "auto", }} >
            <InputForm
                title={"Titel"}
                placeholder={"Titel"}
                value={courseName}
                typeInput={setCourseName}
            />
            <TextAreaForm
                aiReload={aiReload}
                handleAiGenerate={handleAiGenerate}
                aiLoading={aiLoading}
                AI={true}
                size={"large"}
                title={"Beschrijving"}
                placeholder={"Beschrijving"}
                value={`${courseDescription}\n\n${courseExtraDescription}`}
                typeInput={(newValue) => {
                    const [first, second] = newValue.split(/\n\n/);
                    setCourseDescription(first || "");
                    setCourseExtraDescription(second || "");
                }}
            />
        </VerticalLayout>
        <HorizontalLayout style={{gap: "1rem", marginTop: "auto", width: "auto", marginBottom:"1rem", marginLeft:"1rem", marginRight:"1rem"}}>
            <IconButton  style={{ padding: "0.5rem", height: "100%", backgroundColor: "#F7F7F7", borderRadius: "calc(.25rem * var(--br-scale))" }} icon2={"arrow-left"} onClick={dismiss}/>
            <ModalButton style={{ width: "100%", }} onClick={handleEditCourse} title="Opslaan" />
        </HorizontalLayout>
      </VerticalLayout>
    </>
  );
};
